import './Styles/Design.scss';
import card from '../../../Assets/Cards/designAndroid.webp';
import {list1,list2} from '../Desktop/data';
function Design(){
    return(
        <div className="android-design">
            <h1>Design, test and ship amazing products at scale with HostDesign iMac App</h1>
            <p>HostDesign Enterprise transforms your design process, leading to better products, faster.</p>
            <div className="content">
             <img src={card} />
             <ul>
                 {list1.map((item) =>{
                     return(
                         <li>
                             {item.icon}
                             <p>{item.title}</p>
                         </li>
                     )
                 })}
             </ul>
             <ul>
                 {list2.map((item) =>{
                     return(
                         <li>
                             {item.icon}
                             <p>{item.title}</p>
                         </li>
                     )
                 })}
             </ul>
            </div>
        </div>
    )
};
export default Design ;